import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffsAsoElectrocardsOutdatedIndex extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.formatExpiredAso = this.formatExpiredAso.bind(this);
    this.formatExpiredElectro = this.formatExpiredElectro.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulantes/aso/eletrocard/vencimento/aso', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  formatExpiredElectro (cell, row) {
    var data = this.state.data;
    var electrocard_expire_color = '';
    var electrocard_str = '';

    data.map(function(d, index){
      if (d.electrocard_str == cell) {
        electrocard_expire_color = d.electrocard_expire_color;
        electrocard_str = d.electrocard_str;
      }
    });

    var span = (
      <span className={'label label-' + electrocard_expire_color}>
        {electrocard_str}
      </span>
    );

    return span;
  }

  formatExpiredAso (cell, row) {
    var data = this.state.data;
    var aso_expire_color = '';
    var aso_str = '';

    data.map(function(d, index){
      if (d.aso_str == cell) {
        aso_expire_color = d.aso_expire_color;
        aso_str = d.aso_str;
      }
    });

    var span = (
      <span className={'label label-' + aso_expire_color}>
        {aso_str}
      </span>
    );

    return span;
  }

  sortDate(a, b, order, sortField) {
    var field = sortField.replace('_str', '');
    var columnA = Date.parse(a[field]) || 0;
    var columnB = Date.parse(b[field]) || 0;
    if (order === 'desc') {
      return columnA - columnB;
    } else {
      return columnB - columnA;
    }
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Tripulantes.ListaDeASOVencidos.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tripulantes.ListaDeASOVencidos.tabela.semTripulantes}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn width='120' dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>#</TableHeaderColumn>

        <TableHeaderColumn width='300' dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.Tripulante}</TableHeaderColumn>

        <TableHeaderColumn width='100' dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.Matricula}</TableHeaderColumn>

        <TableHeaderColumn  width='90' dataField="date_of_birth_int" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.Idade}</TableHeaderColumn>

        <TableHeaderColumn width='90' dataField="aso_str" dataAlign="center" dataFormat={this.formatExpiredAso} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.ASO}</TableHeaderColumn>

        <TableHeaderColumn width='120' dataField="aso_updated_at_str" dataAlign="center" dataSort={true} sortFunc={this.sortDate} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.AtualizacaoASO}</TableHeaderColumn>

        <TableHeaderColumn width='120' dataField="electrocard_str" dataAlign="center" dataFormat={this.formatExpiredElectro} dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.Eletrocardiograma}</TableHeaderColumn>

        <TableHeaderColumn width='120' dataField="electrocard_updated_at_str" dataAlign="center" dataSort={true} sortFunc={this.sortDate} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>{this.locale.Tripulantes.ListaDeASOVencidos.tabela.AtualizacaoEletro}</TableHeaderColumn>
        
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffsAsoElectrocardsOutdatedIndex;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsAsoElectrocardsOutdatedIndex.js